import { laborHoursConstant } from 'src/redux/actions/constant';

const intitialstate: object = {
  response: null,
  isAddLaborHours: false,
  loading: false,
};

export const addLaborHoursReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case laborHoursConstant.ADD_LABOR_HOURS_SUCCESS: {
      return {
        ...state,
        isAddLaborHours: true,
        response: action.payload,
        loading: false,
      };
    }

    case laborHoursConstant.ADD_LABOR_HOURS_FAILURE:
      return {
        ...state,
        isAddLaborHours: false,
        response: action.payload,
        loading: false,
      };

    case laborHoursConstant.ADD_LABOR_HOURS_LOADER:
      return {
        ...state,
        loading: true,
      };

    case laborHoursConstant.ADD_LABOR_HOURS_RESET:
      return intitialstate;

    default:
      return state;
  }
};
